<div class="container-dropdown">
  <ng-container *ngTemplateOutlet="template" />
  <ng-template #defaultTpl>
    <ng-content />
  </ng-template>
</div>
